export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11418.f330d428.jpg";